import { Tabs, useTabs } from '@common';
import { PageLayout } from '@pages';
import { Outlet } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { tabs } from './data';

type ActiveTabType = 'overview' | 'deposits';

export const FinanceLayoutPage: React.FC = () => {
  const { t } = useTranslation('finance');
  const { activeTab, allowedTabs } = useTabs(tabs);

  return (
    <PageLayout title={t('TITLE')}>
      <Tabs<ActiveTabType> value={activeTab ?? 'overview'}>
        <Tabs.TabsList>
          {allowedTabs.map((tab) => (
            <Tabs.Tab key={tab.value} value={tab.value} to={tab.path}>
              {t(`TABS.${tab.labelKey}`)}
            </Tabs.Tab>
          ))}
        </Tabs.TabsList>
      </Tabs>
      <Outlet />
    </PageLayout>
  );
};
